import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-Informatio",
  "use": "icon-Informatio-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol viewBox=\"0 0 14 14\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-Informatio\">\r\n    <polygon id=\"icon-Informatio_路径\" stroke-width=\"1.16666667\" fill-rule=\"nonzero\" stroke-linejoin=\"round\" points=\"1.16666667 3.47500417 7 5.54166667 12.8333333 3.47500417 7 1.45833333\" />\r\n                <polyline id=\"icon-Informatio_路径\" stroke-width=\"1.16666667\" stroke-linecap=\"round\" stroke-linejoin=\"round\" points=\"1.16666667 5.83333333 7 7.875 12.8333333 5.83333333\" />\r\n                <polyline id=\"icon-Informatio_路径\" stroke-width=\"1.16666667\" stroke-linecap=\"round\" stroke-linejoin=\"round\" points=\"1.16666667 8.1666375 7 10.2083042 12.8333333 8.1666375\" />\r\n                <polyline id=\"icon-Informatio_路径\" stroke-width=\"1.16666667\" stroke-linecap=\"round\" stroke-linejoin=\"round\" points=\"1.16666667 10.5 7 12.5416667 12.8333333 10.5\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/Informatio.svg
// module id = 3NBK
// module chunks = 39